import React, { useRef } from "react";
import { Box, Typography } from "@mui/material";
import globals from "../globals";
import BlueButton from "./blueButton";

// Reusable file picker: an "add files" button, a list of the chosen files, and a
// per-file "remove" button. Originally the inline uploader on the "Стани учител"
// form; extracted so the exam quiz can reuse the same look and behaviour.
//
// `files` items are opaque — pass `getFileName` if a name isn't at `file.name`.
const FileUploadList = ({
    files = [],
    onAdd,
    onRemove,
    getFileName = (file) => file?.name,
    getFileKey = (file, index) => `${getFileName(file)}-${index}`,
    addButtonText = "Добавете файлове",
    accept,
    multiple = true,
    disabled = false,
    uploading = false,
    helperText = null,
    error = false,
}) => {
    const fileInputRef = useRef(null);

    function handleInputChange(event) {
        const selected = Array.from(event.target.files || []);
        // Reset so selecting the same file again still fires onChange.
        event.target.value = "";
        if (!selected.length || !onAdd) return;
        onAdd(selected);
    }

    return (
        <Box>
            <input
                ref={fileInputRef}
                type="file"
                multiple={multiple}
                accept={accept}
                onChange={handleInputChange}
                style={{ display: "none" }}
            />
            <BlueButton
                disabled={disabled || uploading}
                onClick={(event) => {
                    event.preventDefault();
                    fileInputRef.current?.click();
                }}
                text={uploading ? "Качване..." : addButtonText}
            />
            {helperText ? (
                <Typography
                    sx={{
                        mt: 1,
                        color: error ? globals.colors.lightRed : globals.colors.darkBlue,
                        fontSize: 13,
                    }}
                >
                    {helperText}
                </Typography>
            ) : null}
            <Box sx={{ mt: 1 }}>
                {files.map((file, index) => (
                    <Box
                        key={getFileKey(file, index)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1,
                            py: 0.5,
                        }}
                    >
                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 14 }}>
                            {getFileName(file)}
                        </Typography>
                        {!disabled && onRemove ? (
                            <BlueButton
                                size="small"
                                onClick={(event) => {
                                    event.preventDefault();
                                    onRemove(index);
                                }}
                                text="Премахни"
                            />
                        ) : null}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default FileUploadList;
